import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CrudService } from 'src/app/core/services/crud.service';
import { fetchBlogsList, fetchBlogsListSuccess, fetchBlogsListFailure, fetchBlogsDetail, fetchBlogsDetailSuccess, fetchBlogsDetailFailure, addUpdateBlog, addUpdateBlogFailure, addUpdateBlogSuccess, deleteBlog, deleteBlogFailure, deleteBlogSuccess } from './blogs.action';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class BlogsEffects {
  constructor(
    private actions$: Actions,
    private CrudService: CrudService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  fetchData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchBlogsList),
      mergeMap((action:any) =>
        this.CrudService.fetchData(
          `Blog/GetAllBlogs?PageNumber=${action.payload.pageNumber}&PageSize=${action.payload.pageSize}
          &SortColumn=${action.payload.sortColumn}&SortOrder=${action.payload.sortOrder}&Search=${action.payload.search}`).pipe(
          map((result) => fetchBlogsListSuccess({ response: result })),

          catchError((error) => of(fetchBlogsListFailure({ error })))
        )
      )
    )
  );

  fetchDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchBlogsDetail),
      mergeMap((action) =>
        this.CrudService.getData('Blog/GetBlog?Id=' + action.payload.id).pipe(
          map((result) => fetchBlogsDetailSuccess({ response: result })),

          catchError((error) => of(fetchBlogsDetailFailure({ error })))
        )
      )
    )
  );

  addUpdateBlog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addUpdateBlog),
      mergeMap((action) =>
        this.CrudService.postData('Blog/CreateUpdateBlog', action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.open('Blog Update successfully', '', {
                duration: 3000,
                panelClass: 'success',
              });
              this.router.navigate(['/blogs'])
            } else {
              this.snackBar.open(result.message, '', {
                duration: 3000,
                panelClass: 'danger',
              });
            }
          }),
          map((res) => addUpdateBlogSuccess({ response: res.result })),
          catchError((error) => {
            return of(addUpdateBlogFailure({ error }));
          })
        )
      )
    )
  );

  deleteBlog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteBlog),
      mergeMap((action) =>
        this.CrudService.deleteData(`Blog/DeleteBlog?Id=${action.payload.id}`).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.open('Blog Deleted successfully', '', {
                duration: 3000,
                panelClass: 'success',
              });
            } else {
              this.snackBar.open(result.message, '', {
                duration: 3000,
                panelClass: 'danger',
              });
            }
          }),
          mergeMap((res) => [
            deleteBlogSuccess({ response: res.result }),
            fetchBlogsList({
              payload: { pageNumber: 1, pageSize: 10, sortColumn: 'id', sortOrder: 'z', search: '' }
            })
          ]),
          catchError((error) => of(deleteBlogFailure({ error })))
        )
      )
    )
  );
}
